module.exports = __webpack_public_path__ + "static/media/img_questionnaire_null.18e39631.svg";